import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useCallback, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { createUseStyles, Input, Select, Slider } from 'hoi-poi-ui';
import styles from "./styles.js";
const useStyles = createUseStyles(styles, 'EditForm');
const EditForm = _ref => {
  let {
    form,
    onBlur,
    onChange,
    modalInputRef,
    className,
    schema
  } = _ref;
  const classes = useStyles();
  const {
    values,
    errors,
    touched
  } = form;
  useEffect(() => {
    var _modalInputRef$curren;
    modalInputRef === null || modalInputRef === void 0 ? void 0 : (_modalInputRef$curren = modalInputRef.current) === null || _modalInputRef$curren === void 0 ? void 0 : _modalInputRef$curren.focus();
  }, [modalInputRef]);
  const handleOnChange = useCallback(field => value => {
    onChange && onChange({
      field,
      value
    });
  }, [onChange]);
  const parseFormSchema = useMemo(() => {
    return schema.map((field, index) => {
      var _field$attrs;
      const {
        placeholder,
        label,
        name,
        isRequired,
        isFullWidth,
        isReadOnly
      } = field;
      let Field = null;
      let fieldProps = {
        placeholder,
        label,
        isRequired,
        isFullWidth,
        isReadOnly,
        ref: index === 0 ? ref => modalInputRef.current = ref : undefined,
        value: values && values[name],
        onChange: handleOnChange(name),
        onBlur: value => onBlur({
          field: name,
          value
        }),
        error: touched[name] && errors[name],
        key: `edit-${name}-${index}`
      };
      switch (field.type) {
        case 'text':
          Field = Input;
          break;
        case 'select':
          Field = Select;
          fieldProps = _objectSpread(_objectSpread({}, fieldProps), {}, {
            isClearable: false,
            options: field.attrs.options
          });
          break;
        case 'slider':
          Field = Slider;
          fieldProps = _objectSpread(_objectSpread({}, fieldProps), {}, {
            isPercentage: field.isPercentage,
            overrides: (_field$attrs = field.attrs) === null || _field$attrs === void 0 ? void 0 : _field$attrs.overrides,
            step: field.step || 1
          });
          break;
        default:
          return Field;
      }
      return /*#__PURE__*/React.createElement(Field, fieldProps);
    });
  }, [errors, handleOnChange, modalInputRef, onBlur, schema, touched, values]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.root, className)
  }, parseFormSchema);
};
export default /*#__PURE__*/memo(EditForm);